import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';

import MainPagetitle from '../../layouts/MainPagetitle';
import PaymentDetailService from '../../api/services/PaymentDetailService';
import { Modal, Button } from 'react-bootstrap';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
const EditDocument = () => {
    var imageUrl = process.env.REACT_APP_LARAVEL_IMAGE_URL;
    const params = useParams();
    const navigate = useNavigate();
    const [blogModal, setBlogModal] = useState(false);
    const [blog, setBlog] = useState([]);
    const [file, setFile] = useState()
    const [error, setError] = useState([]);
    const [documentTitle, setDocumentTitle] = useState('');

    const [isLoading, setisloading] = useState(true);

    useEffect(() => {
        if (localStorage.getItem("admintoken")) {
            var id = params.id;
            getBlogByID(id);
        }
        else {
            navigate('/')
        }
    }, []);

    const getBlogByID = async (id) => {
        try {
            let blogList = await PaymentDetailService.getdocumentbyid(id).json();
            setBlog(blogList.data);
            setDocumentTitle(blogList.data.document_title);

            setisloading(false);
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }
    };

    const onFileChange = (e) => {
        // Check if files are selected and that there's at least one file
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];

            // Proceed only if the file is of valid type (Blob)
            const fileReader = new FileReader();

            fileReader.onload = () => {
                const blog_image = fileReader.result;
                setFile(blog_image);
            };

            fileReader.onerror = (error) => {
                console.error("FileReader error:", error);
            };

            // Read the file as a data URL
            fileReader.readAsDataURL(file);
        } else {
            // Handle case when no file is selected or file selection was canceled
            console.log("No file selected or file selection canceled.");
            setFile(null); // You can clear the file or handle it based on your needs
        }
    };


    const onSubmitForm = async (event) => {
        event.preventDefault();
        setError("")
        try {
            var userData = {
                "id":params.id,
                "user_id": blog.user_id,
                "document_title": documentTitle ? documentTitle : "_",
                "document_upload": file ? file.split(',')[1] : "",

            }

            let responseData = await PaymentDetailService.updatedocument(userData).json()

            if (responseData.status === true) {
                setBlogModal(true)
            }
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message)
            }
        }

    };

    return (
        <>
            <MainPagetitle mainTitle="Edit Document" pageTitle={'Edit Document'} parentTitle={'Home'} />
            <div className="container-fluid">
                <form className="form-valide" onSubmit={onSubmitForm}>
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-header">
                                    <h4 className="card-title">Edit Document</h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">

                                        <div className="col-xl-12 mb-3">
                                            <label htmlFor="val-username" className="form-label" >Document Title<span className="text-danger">*</span></label>


                                            <select className="form-control" name="document_title"
                                                value={documentTitle}
                                                onChange={(e) => setDocumentTitle(e.target.value)} // Handle change to update state
                                            >
                                                <option value="Drivers License (Front Side)">Drivers License (Front Side)</option>
                                                <option value="Drivers License (Back Side)">Drivers License (Back Side)</option>
                                                <option value="ID (Front Side)">ID (Front Side)</option>
                                                <option value="ID (Back Side)">ID (Back Side)</option>
                                            </select>
                                        </div>

                                        <div className="col-xl-12 mb-3">

                                            <label htmlFor="val-number" className="form-label"> Document upload <span className="text-danger">*</span></label>
                                            {
                                                blog.document_upload ?
                                                    <img className="img-drop-area" height={blog.document_upload ? 100 : 0} width={blog.document_upload ? 100 : 0} src={imageUrl + "Document/" + blog.document_upload} alt='' />
                                                    :
                                                    <img className="img-drop-area" height={file ? 100 : 0} width={file ? 100 : 0} src={file ? file : ""} alt='' />

                                            }
                                            <input type="file" className="form-control" name='document_upload' id="val-number" accept="image/png, image/jpeg" onChange={onFileChange} />
                                        </div>



                                    </div>
                                    <h5 style={{ color: 'red' }}>{error}</h5>
                                    <div>
                                        <button type="submit" className="btn btn-primary me-1">Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </form>
            </div>
            {isLoading && <LogoAnimationLoader />}
            <Modal centered className="mark-attendence" show={blogModal}>
                <Modal.Header>
                    <Modal.Title>Update </Modal.Title>
                    <Button variant="" className="btn-close" onClick={() => setBlogModal(false)}></Button>
                </Modal.Header>
                <Modal.Body>Update Document Successfully!!!.</Modal.Body>
                <Modal.Footer>
                    <Link className="btn btn-primary" to={`/admin/documents/${blog.user_id}`} variant="danger light" onClick={() => setBlogModal(false)}>Close</Link>
                </Modal.Footer>
            </Modal>
        </>
    );
};
export default EditDocument;